export default {"src":"/_next/static/media/stepdividerKyc.cbaf1014.svg","height":132,"width":2,"blurWidth":0,"blurHeight":0};